import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ModalComponent } from '../../modal/modal.component';
import { SharedModule } from 'src/app/modules/shared.module';
import { TermsAndConditionsService } from 'src/app/services/terms-and-conditions.service';
import { CLIENT_ID } from '@environments/environment';
import { LoaderService } from 'src/app/services/loader.service';
import { RouterModule } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-terms-and-conditions-modal',
  imports: [
    ModalComponent,
    SharedModule,
    RouterModule,
  ],
  templateUrl: './terms-and-conditions-modal.component.html',
  styleUrl: './terms-and-conditions-modal.component.scss'
})
export class TermsAndConditionsModalComponent implements AfterViewInit {

  @ViewChild('modal', { static: false }) modal!: ModalComponent;

  constructor(
    private readonly tecService: TermsAndConditionsService,
    private readonly loaderService: LoaderService,
    private readonly authService: AuthService,

    public readonly sharedService: SharedService,
  ) {
    if (!this.tecService.flag()) {
      this.loaderService.show();
    }
  }

  ngAfterViewInit(): void {
    if (!this.tecService.flag()) {
      setTimeout(() => {
        this.openModal();
        this.loaderService.hide();
      }, 500)
    }
  }

  openModal() {
    this.modal.buildModal(() => { }, 'md', 'terms-and-conditions-modal');
  }

  handleAccept() {
    this.tecService.setFlag(true);
    if (!this.authService.user?.isUserGenerallyHQ) {
      this.sharedService.navigateTo_SetStorePage();
    }
    this.modal.dismiss();
  }

  handleClickLink() {
    this.modal.dismiss();
  }
}
